import { render, staticRenderFns } from "./DashboardSales.vue?vue&type=template&id=8e6c7632&scoped=true&"
import script from "./DashboardSales.vue?vue&type=script&lang=js&"
export * from "./DashboardSales.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSales.vue?vue&type=style&index=0&id=8e6c7632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6c7632",
  null
  
)

export default component.exports